import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {environment} from '../../../../environments/environment';
import {DatePipe} from '@angular/common';
import {LogViewItem} from '../../../models/log/logviewitem';
import {LogViewItemService} from '../../../service/log/service-logviewitem';
import {Subject} from 'rxjs';

@Component({
  templateUrl: './logviewitem.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LogViewItemEgovComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public  onClose: Subject<boolean>;
  public id :  number;
  public type: string;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public dataList: LogViewItem[];
  public fromDate: Date;
  public toDate: Date;
  constructor( public logViewItemService: LogViewItemService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public _bsModalRef: BsModalRef,
               public commandUtil: CommandUtil,
               public datePipe: DatePipe
  ) {
  }
  ngAfterViewInit() {

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();


  }
  public  show(id: number, type: string)
  {
      this.id = id;
      this.type = type;
      this.search();
  }
  search()
  {
    let fDate :string = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    let tDate :string = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
    this.logViewItemService.findAllByPaging(this.id, this.type,  fDate, tDate, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.logViewItemService.getCount(this.id , this.type,  fDate, tDate).subscribe(recordCount => this.totalItems = recordCount);
  }


  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }
  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }
  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
}

